import { useEffect } from 'react';

import { setPrimeurUser } from '@/redux/slices/primeur.slice';

import { useAppDispatch, useAppSelector } from '@/redux';
import { LocalStorageService } from '@/services/LocalStorage.service';
import { useFeature } from './useFeature';
import { FEATURES } from '@/constants/features';
import { KEYS } from '@/constants/keys';

export const usePrimeurUser = ({ hashUserFromQuery, isAlertable = true, currentLink = undefined }) => {
  const dispatch = useAppDispatch();
  const { storeConf } = useAppSelector(({ root }) => root);
  const { content: currentUser } = useAppSelector(({ user }) => user);
  const isCampaignFeatureEnabled = useFeature(storeConf, FEATURES.PRIMEUR_CAMPAIGN);

  useEffect(() => {
    if (isAlertable && isCampaignFeatureEnabled) {
      const idUser = currentUser?._id;
      const hash = hashUserFromQuery || LocalStorageService.getObject(KEYS.HASH_USER);

      if (idUser || hash) {
        dispatch(setPrimeurUser({
          content: { idUser: idUser, hashPrimeurUser: hash, storeId: storeConf.storeId }
        }));
      }
    }
  }, [currentUser, currentLink]);
};
